import { 
    CHECKOUT_SET_DELIVERY,
    CHECKOUT_SET_PAYMENT,
} from '../Actions/Checkout.action';

const defaultState = { 
    payload: {
        selectedDeliveryMethod: {},
        selectedPaymentMethod: {},

        deliveryMethods: [],
        paymentMethods: [],
        redirectUrl: '',
    }, 
    errors: {},
    result: {}, 
}

export const punchoutCheckout = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case CHECKOUT_SET_DELIVERY:
        case CHECKOUT_SET_PAYMENT:
            return {
                ...state,
                payload: {
                    ...state.payload,
                    ...payload,
                }
            }
        default:
            return state;
    }
}